import React, { useState } from 'react'
import ApiService from '../../../../store/services/ApiService'
import * as companyAPI from '../../../../store/api/company'
import ChooseImageField from '../../../../components/Form/FormFields/ChooseImageField'

const CompanyRecruiterAvatarUploadContainer = ({ value, error, touched, handleField }) => {
  const [state, setState] = useState({
    isLoading: false,
    apiError: ''
  })

  const handleChange = (file, onSuccess) => {
    const formData = new FormData()
    formData.append('file', file, file.name)

    ApiService.fetch(companyAPI.uploadRecruiterAvatar(formData))
      .then((data) => {
        setState({ ...state, isLoading: false })
        handleField('avatarUrl', data.url)
        onSuccess()
      })
      .catch(err => setState({ ...state, apiError: err }))
  }

  return (
    <ChooseImageField
      buttonSelectLabel='Wybierz zdjęcie (PNG/JPG)'
      chooseFileButtonDescription='Dodaj zdjęcie rekrutera.'
      chooseFileButtonFieldlabel='Zdjęcie Rekrutera'
      croppedImageHeadingText='Zaznacz obszar zdjęcia rekrutera, a następnie wyślij plik.'
      errorMessage={error}
      hasError={error && touched}
      image={value}
      isLoading={state.isLoading}
      onChange={handleChange}
      withHash
    />
  )
}

export default CompanyRecruiterAvatarUploadContainer
